import React, { useMemo } from 'react'
import { Field, Select } from '@workwhile/ui'
import { ADMIN_VISIBLE_COMPUMATIC_PUNCH_STATUSES } from '../adminVisibleCompumaticPunchStatuses'
import { formatCompumaticPunchStatus } from '../formatCompumaticLabels'

type StatusPickerProps = {
  value: string | null
  onChange: (value: string | undefined) => void
}

export const StatusPicker = ({ value, onChange }: StatusPickerProps) => {
  const options = useMemo(
    () =>
      ADMIN_VISIBLE_COMPUMATIC_PUNCH_STATUSES.map((status) => ({
        label: formatCompumaticPunchStatus(status),
        value: status,
      })),
    []
  )

  return (
    <Field label="Status">
      <Select
        block
        isClearable
        placeholder="All punch statuses"
        options={options}
        value={options.find((option) => option.value === value) ?? null}
        onChange={(option) => {
          onChange(option?.value ?? undefined)
        }}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 10011,
            pointerEvents: 'auto',
          }),
        }}
      />
    </Field>
  )
}
